import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, isDevMode } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppService } from '@services/app.service';
import { DeviceIdService } from '@services/device-id.service';
import { SegnalatoreService } from '@services/segnalatore.service';
import { AppStore } from '@services/store/app.store';
import { UserService } from '@services/user.service';
import { AppRoutingModule, routes } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { httpInterceptor } from './app/core/interceptors/httpConfig.interceptor';
import { LoadingService } from './app/core/services/loading.service';
import { Console } from './app/shared/providers/custom-logger';

// Aggiungiamo un handler globale per gli errori non catturati
window.onerror = function(message, source, lineno, colno, error) {
  Console.log('Global error:', { message, source, lineno, colno, error }, 'err');
  return false;
};

// Aggiungiamo un handler per le promise non gestite
window.onunhandledrejection = function(event) {
  Console.log('Unhandled promise rejection:', event.reason, 'err');
};

// usare ng build --prod
// if (environment.production) {
//   enableProdMode();
// }

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      CommonModule,
      AppRoutingModule,
      ReactiveFormsModule,
      FormsModule,
      IonicStorageModule.forRoot({
        name: 'PrimoAppDB',
        driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
      })
    ),
    Platform,
    AppService,
    AppStore,
    LoadingService,
    provideRouter(routes),
    importProvidersFrom(
      IonicModule.forRoot({
        innerHTMLTemplatesEnabled: true,
        rippleEffect: false,
        animated: true,
        mode: 'md',
        _forceStatusbarPadding: false,
        _testing: true,
        _zoneGate: (h: any) => h
      })
    ),
    UserService,
    SegnalatoreService,
    DeviceIdService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(
      withInterceptors([httpInterceptor])
    ),
    // Registrazione SW minimale (nessun caching) per rendere l'app installabile come PWA
    // lasciando gli aggiornamenti al browser.
    // Attivo solo in ambienti non development.
  ],
}).catch((err) => {
  Console.log('main.ts errore', err, 'err');
});

// Registra un SW minimale in produzione per installabilità PWA, senza gestire caching
if ('serviceWorker' in navigator && !isDevMode()) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      Console.log('SW registration failed', err, 'err');
    });
  });
}
